module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Bluetooth-472e73b35627f8bee6b08dc21eca9f5c.svg";